export const allFacilities = ({ coachFacilities = [], academies = [] }) => {
  const facilities = coachFacilities.concat(
    academies.map(academy => academy.facilities ?? []),
  )
  return facilities.flat()
}
